// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__G0z7H","loader":"MediumLoader_loader__9LSQg","spinner-c7wet2":"MediumLoader_spinner-c7wet2__j3EoV"};